// extracted by mini-css-extract-plugin
export var actionButton = "_j7-t";
export var buttonContainer = "_j7-0";
export var buttonContainer2 = "_j7-1";
export var buttonSection = "_j7-2";
export var details = "_j7-3";
export var dropdownItem = "_j7-5";
export var dropdownItemsContainer = "_j7-4";
export var fileInput = "_j7-r";
export var headerButton = "_j7-6";
export var icon = "_j7-7";
export var input = "_j7-8";
export var macroListItem = "_j7-9";
export var mainContent = "_j7-a";
export var microText = "_j7-b";
export var modal = "_j7-w";
export var optionsButton = "_j7-c";
export var paperclip = "_j7-s";
export var pillContent = "_j7-d";
export var preview = "_j7-e";
export var preview2 = "_j7-f";
export var quillEditor = "_j7-q";
export var selectedMacro = "_j7-g";
export var sidebar = "_j7-h";
export var sidebarHeader = "_j7-j";
export var sidebarList = "_j7-i";
export var sidebarListItem = "_j7-k";
export var sidebarSearch = "_j7-l";
export var snoozeDurationWrapper = "_j7-v";
export var statusPillContainer = "_j7-m";
export var tagsContainer = "_j7-n";
export var unselectedMacro = "_j7-o";
export var variable = "_j7-u";
export var wrapper = "_j7-p";